import logo from "assets/images/dark_logo.png";
import { Sidebar } from "primereact/sidebar";
import { useState } from "react";
import { AiOutlineLoading3Quarters, AiOutlineLogout, AiOutlineMenu } from "react-icons/ai";
import { BsTelephoneForward } from "react-icons/bs";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { RiAccountPinCircleLine } from "react-icons/ri";
import { NavLink, useHistory } from "react-router-dom";
import useLogout from "api/UserResource/useLogout";
import useNavigationLinks from "./useNavigationLinks";

const MENU_LINK_CSS = `px-2 py-1 text-akgreenest flex gap-3 items-center bg-transparent`;

const MobileMenu = ({ children, isAuthenticated }) => {
	const menu = useNavigationLinks();

	const { push } = useHistory();

	const [visibleLeft, setVisibleLeft] = useState(false);

	const { mutateAsync, isLoading } = useLogout();
	const handleLogout = async () => {
		setVisibleLeft(false);
		await mutateAsync();
	};

	const handleChangePath = (path) => {
		setVisibleLeft(false);
		push(path);
	};

	const logoWidth = 80;

	return (
		<div className="flex justify-between w-full">
			<NavLink to="/">
				<img
					src={logo}
					alt="Akello Library"
					width={logoWidth}
				/>
			</NavLink>

			<div className="flex items-center justify-end gap-4">
				{children}

				<button
					type="button"
					onClick={() => setVisibleLeft(true)}
				>
					<AiOutlineMenu
						className="text-akgreenest"
						size={20}
					/>
				</button>
			</div>

			<Sidebar
				visible={visibleLeft}
				position="left"
				className="font-sans"
				onHide={() => setVisibleLeft(false)}
			>
				<ul className="flex flex-col gap-2 mobile-menu">
					{menu.map((item) => {
						return (
							<button
								type="button"
								onClick={() => handleChangePath(item.to)}
								className={MENU_LINK_CSS}
							>
								{item.icon}
								{item.label}
							</button>
						);
					})}

					<button
						type="button"
						onClick={() => handleChangePath("/support")}
						className={MENU_LINK_CSS}
					>
						<BsTelephoneForward /> Support
					</button>

					{isAuthenticated && (
						<button
							type="button"
							onClick={() => handleChangePath("/my-account")}
							className={MENU_LINK_CSS}
						>
							<RiAccountPinCircleLine /> My Account
						</button>
					)}

					{isAuthenticated && (
						<button
							type="button"
							onClick={handleLogout}
							disabled={isLoading}
							className={MENU_LINK_CSS}
						>
							{isLoading ? (
								<AiOutlineLoading3Quarters size={18} className="animate-spin" />
							) : (
								<AiOutlineLogout size={18} />
							)}
							Logout
						</button>
					)}

					<button
						type="button"
						onClick={() => handleChangePath("/downloads")}
						className={MENU_LINK_CSS}
					>
						<IoCloudDownloadOutline /> Downloads
					</button>
				</ul>
			</Sidebar>
		</div>
	);

	//!
};

export default MobileMenu;
